export default __webpack_public_path__ + "static/studycafe-study1-c32f6f59e786979d5b28af3e6bd46516.jpg";